/* istanbul ignore file */
import { css } from 'styled-components';

const buttonReset = css`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

const baseStyles = css`
  text-align: center;
`;

export const baseLink = css`
  ${baseStyles}
  text-decoration: none;
  display: inline-block;
`;

export const baseButton = css`
  ${buttonReset}
  ${baseStyles}
  &:disabled {
    pointer-events: none;
  }
`;
